import { Typography } from '@mui/material';

export const FORM_LABEL_WIDTH = 'min(40%, 140px)';

export const FormLabel = ({ label }: { label?: string }) => {
  return (
    <Typography
      variant="subtitle2"
      sx={{
        width: FORM_LABEL_WIDTH,
        flexShrink: 0,
        color: (theme) => theme.palette.custom.OV.sys.outline,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {label}
    </Typography>
  );
};
